import http from '@/plugins/api'
import * as types from './types'
import {
  startLoading
} from '@/plugins/loading'

export default {
  async getDevices({ commit, dispatch }, searchOptions, id) {
    const r = await startLoading(dispatch, 'getDevices', () =>
      http.get(`device/GetDevicesForListing`, {
        params: searchOptions
      })
    )
    commit(types.SET_DEVICES, r.data)
  },
  async getThumbnails({ dispatch }, data) {
    const r = await startLoading(dispatch, 'getThumbnails', () =>
      http.get(`file/thumbsBase64?path=GlassTech/${data.vin}/${data.id}`)
    )
    return r.data
  },
  async getFile({ dispatch }, file) {
    const r = await startLoading(dispatch, 'getFile', () =>
      http.get(`file/fileBase64?file=${file}`)
    )
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/actions.js